import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {Favorite, FavoriteList} from '@models/favorite';
import {AdService} from '@services/ad.service';
import {EMPTY_FAVORITE_LIST} from '@models/empty';
import {MatTableDataSource} from '@angular/material/table';
import {ListService} from '@services/list.service';
import {AuthenticationService} from '@services/authentification.service';
import {TrackingService} from '@services/tracking.service';
import {AlertService} from '@services/alert.service';

@Component({
    selector: 'app-historic',
    templateUrl: './historic.component.html',
    styleUrls: ['./historic.component.scss']
})
export class HistoricComponent implements OnInit {

    favoritesList: FavoriteList = EMPTY_FAVORITE_LIST;
    loading = true;
    dataSource = new MatTableDataSource<Favorite>();

    displayedColumns: string[] = [];

    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
    @ViewChild(MatSort, {static: true}) sort: MatSort;

    constructor(
        public dialog: MatDialog,
        public authenticationService: AuthenticationService,
        private adService: AdService,
        private alertService: AlertService,
        private listService: ListService,
        public trackingService: TrackingService
    ) {
    }

    initDataSource() {
        this.dataSource.paginator = this.paginator;
    }

    ngOnInit() {
        this.listService.getColumns().subscribe(params => {
            this.displayedColumns = ['title', 'price', 'ad_city.zip_code', 'ad_city.name', 'action'];
            this.initDataSource();
        });

        this.loading = true;
        this.adService.getFavoritesList('historic').subscribe(result => {
            const that = this;
            result.favorites.forEach((fav, i) => {
                result.favorites[i] = that.adService.updateValues(fav);
            });
            this.favoritesList = result;
            this.dataSource = new MatTableDataSource<Favorite>(result.favorites);
            this.initDataSource();
            this.loading = false;
        }, error => {
            if (error != 'token_outdate') {
                this.alertService.error('Liste introuvable');
            }
        });

        setTimeout(() => {
            this.initDataSource();
        }, 100);
    }
}
